export const AUTHENTICATION = 'authentication';
export const INDEX = 'index';
export const CONFIRM_DIALOG = 'confirm-dialog';
export const SIDEBAR = 'sidebar';
export const SIGNUP = 'signup';
export const TOAST = 'toast';
export const PEOPLE = 'people';
export const ONBOARDING = 'onboarding';

export const collection = [
	AUTHENTICATION,
	CONFIRM_DIALOG,
	INDEX,
	SIDEBAR,
	SIGNUP,
	TOAST,
	PEOPLE,
	ONBOARDING,
];

export default {
	AUTHENTICATION: AUTHENTICATION,
	CONFIRM_DIALOG: CONFIRM_DIALOG,
	INDEX: INDEX,
	SIDEBAR: SIDEBAR,
	SIGNUP: SIGNUP,
	TOAST: TOAST,
	PEOPLE: PEOPLE,
	ONBOARDING: ONBOARDING,
};
